import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_vuesocialsharingplugin_097f1e3f from 'nuxt_plugin_vuesocialsharingplugin_097f1e3f' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_apolloapi_084619f2 from 'nuxt_plugin_apolloapi_084619f2' // Source: ../plugins/apollo_api.js (mode: 'all')
import nuxt_plugin_filters_6977db3c from 'nuxt_plugin_filters_6977db3c' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_auth_e9a0226e from 'nuxt_plugin_auth_e9a0226e' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_matterjs_9d6105c2 from 'nuxt_plugin_matterjs_9d6105c2' // Source: ../plugins/matter-js (mode: 'all')
import nuxt_plugin_pathseg_90ba444c from 'nuxt_plugin_pathseg_90ba444c' // Source: ../plugins/pathseg (mode: 'all')
import nuxt_plugin_polydecomp_742a86fb from 'nuxt_plugin_polydecomp_742a86fb' // Source: ../plugins/poly-decomp (mode: 'all')
import nuxt_plugin_globalComponents_78b430b8 from 'nuxt_plugin_globalComponents_78b430b8' // Source: ../plugins/globalComponents.js (mode: 'client')
import nuxt_plugin_facebookpixel_3eb7085c from 'nuxt_plugin_facebookpixel_3eb7085c' // Source: ../plugins/facebook-pixel.js (mode: 'client')
import nuxt_plugin_vkpixel_d6276f7a from 'nuxt_plugin_vkpixel_d6276f7a' // Source: ../plugins/vk-pixel.js (mode: 'client')
import nuxt_plugin_yametrika_6a0a238d from 'nuxt_plugin_yametrika_6a0a238d' // Source: ../plugins/ya-metrika.js (mode: 'client')
import nuxt_plugin_history_c7db41ae from 'nuxt_plugin_history_c7db41ae' // Source: ../plugins/history.js (mode: 'client')
import nuxt_plugin_vuexpersistedstate_7818c624 from 'nuxt_plugin_vuexpersistedstate_7818c624' // Source: ../plugins/vuex-persistedstate.js (mode: 'client')
import nuxt_plugin_telegramlinks_6736dc38 from 'nuxt_plugin_telegramlinks_6736dc38' // Source: ../plugins/telegram-links.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Онлайн-школа Синергия","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"google","content":"notranslate"},{"name":"yandex-verification","content":"27398efaf1014815"},{"hid":"description","name":"description","content":"подготовка к ЕГЭ\u002FОГЭ"},{"hid":"og:title","name":"og:title","content":"Онлайн-школа Синергия"},{"hid":"og:description","name":"og:description","content":"Домашняя онлайн-школа Синергия приглашает учеников со всей страны на дистанционное семейное обучение по школьным программам 7-11 классов и подготовку к ЕГЭ\u002FОГЭ"},{"hid":"og:image","name":"og:image","content":"\u002Fimg\u002Fhead_preview.jpg"},{"hid":"twitter:card","name":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"og:image:alt","name":"og:image:alt","property":"og:image:alt","content":"\u002Fimg\u002Fhead_preview.jpg"},{"hid":"fb:image:url","name":"fb:image:url","property":"fb:image:url","content":"\u002Fimg\u002Fhead_preview.jpg"},{"hid":"twitter:image","name":"twitter:image","property":"twitter:image","content":"\u002Fimg\u002Fhead_preview.jpg"},{"hid":"og:image:type","name":"og:image:type","property":"og:image:type","content":"image\u002Fjpg"},{"hid":"format-detection","name":"format-detection","content":"telephone=no"},{}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"preload","as":"image","href":"\u002Fimg\u002Fheader-students.svg"}],"script":[{"href":"\u002Fjquery-3.6.0.min.js","async":true,"defer":true},{"href":"\u002Fjquery.activity.min.js","async":true,"defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_vuesocialsharingplugin_097f1e3f === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_097f1e3f(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_apolloapi_084619f2 === 'function') {
    await nuxt_plugin_apolloapi_084619f2(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_6977db3c === 'function') {
    await nuxt_plugin_filters_6977db3c(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_e9a0226e === 'function') {
    await nuxt_plugin_auth_e9a0226e(app.context, inject)
  }

  if (typeof nuxt_plugin_matterjs_9d6105c2 === 'function') {
    await nuxt_plugin_matterjs_9d6105c2(app.context, inject)
  }

  if (typeof nuxt_plugin_pathseg_90ba444c === 'function') {
    await nuxt_plugin_pathseg_90ba444c(app.context, inject)
  }

  if (typeof nuxt_plugin_polydecomp_742a86fb === 'function') {
    await nuxt_plugin_polydecomp_742a86fb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalComponents_78b430b8 === 'function') {
    await nuxt_plugin_globalComponents_78b430b8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebookpixel_3eb7085c === 'function') {
    await nuxt_plugin_facebookpixel_3eb7085c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vkpixel_d6276f7a === 'function') {
    await nuxt_plugin_vkpixel_d6276f7a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yametrika_6a0a238d === 'function') {
    await nuxt_plugin_yametrika_6a0a238d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_history_c7db41ae === 'function') {
    await nuxt_plugin_history_c7db41ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistedstate_7818c624 === 'function') {
    await nuxt_plugin_vuexpersistedstate_7818c624(app.context, inject)
  }

  if (typeof nuxt_plugin_telegramlinks_6736dc38 === 'function') {
    await nuxt_plugin_telegramlinks_6736dc38(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
